import AdminHeader from "components/Headers/AdminHeader";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardFooter,
  Button,
  Input,
  FormGroup,
  Label,
  Tooltip,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import { REGEX } from "constants/CommonConstants";
import Avatar from "components/CommonComponents/Avatar";
import {
  getAdminProfileDetails,
  updateAdminProfileDetails,
} from "action/admin";

const initialFields = {
  firstName: {
    value: "",
    error: "",
  },
  lastName: {
    value: "",
    error: "",
  },
  fullName: {
    value: "",
    error: "",
  },
  email: {
    value: "",
    error: "",
  },

  mobile: {
    value: "",
    error: "",
  },
  // Read-only fields
  role: {
    value: "",
  },
  accountStatus: {
    value: "ACTIVE",
  },
  createdOn: {
    value: "",
  },
  profilePhoto: {
    value: null,
    error: "",
  },
};

function AdminProfile() {
  const [formData, setFormData] = useState(initialFields);
  const [profileState, setProfileState] = useState({
    isEditing: false,
    originalFormData: initialFields,
  });
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
const [listState, setListState] = useState({
    isLoading: true,
    error: "",
  });
  const fetchAdminProfile = async () => {
    try {
      setListState({
        isLoading: true,
        error: "",
      });

      const res = await getAdminProfileDetails();

      if (res?.code === 200) {
        const data = res.data;

        const mappedData = {
          firstName: {
            value: data?.firstName || "",
            error: "",
          },

          lastName: {
            value: data?.lastName || "",
            error: "",
          },

          fullName: {
            value: data?.fullName || "",
            error: "",
          },

          email: {
            value: data?.email || "",
            error: "",
          },

          mobile: {
            value: data?.mobile || "",
            error: "",
          },
          role: {
            value: data?.role || "",
          },
          accountStatus: {
            value: data?.status || "ACTIVE",
          },
          createdOn: {
            value: data?.createdOn || "",
          },
          profilePhoto: {
            value: data?.profilePhoto || null,
            error: "",
          },
        };

        setFormData(mappedData);
        setProfileState((prev) => ({
          ...prev,
          originalFormData: mappedData,
        }));
        setListState({
          isLoading: false,
          error: "",
        });
      } else {
        setListState({
          isLoading: false,
          error: res?.message || "Failed to load admin profile",
        });
      }
    } catch (error) {
      setListState({
        isLoading: false,
        error:
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong while fetching admin profile",
      });
    }
  };

  useEffect(() => {
    fetchAdminProfile();
  }, []);
  const handleSave = async () => {
    try {
      const bodyData = {
        firstName: formData.firstName?.value || "",
        lastName: formData.lastName?.value || "",
      };
      const res = await updateAdminProfileDetails(bodyData);
     if (res?.code === 200) {
        setProfileState((prev) => ({
          ...prev,
          isEditing: false,
        }));
         await fetchAdminProfile();
         return;
      } else {  setListState({
        isLoading: false,
        error: res?.message || "Failed to update admin profile",
      });
    }
    } catch (error) {
      setListState({
        isLoading: false,
        error:
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong while updating admin profile",
      });
      }
  };
  const handleEdit = () => {
    setProfileState((prev) => ({
      ...prev,
      originalFormData: formData,
      isEditing: true,
    }));
  };

  const handleInputChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: {
        value: value,
        error: "",
      },
    }));
  };

  const getValidationError = (name, value) => {
    switch (name) {
      case "fullName":
        if (!value) return "Full name is required";
        else if (value.length < 3 || value.length > 100)
          return "Full name must be 3–100 characters";
        else if (!REGEX.ONLY_ALPHABETS_REGEX.test(value))
          return "Only alphabets and spaces allowed";
        return "";

      case "email":
        if (!value) return "Email is required";
        else if (!REGEX.EMAIL_REGEX.test(value)) return "Invalid email format";
        return "";

      case "mobileNo":
        if (!value) return "Mobile number is required";
        else if (!REGEX.PHONE_NO_REGEX.test(value))
          return "Enter valid mobile number";
        return "";

      case "address":
        if (value.length > 250)
          return "Address should less than 250 characters";
        return "";

      default:
        return "";
    }
  };

  const handleBlur = (name, value) => {
    const error = getValidationError(name, value);
    setFormData((prev) => ({
      ...prev,
      [name]: { value, error },
    }));
  };

  const handleOnCancel = () => {
    setFormData(profileState.originalFormData);
    setProfileState((prev) => ({
      ...prev,
      isEditing: false,
    }));
  };
  return (
    <>
      <AdminHeader name="My Profile" />
      {listState.isLoading ? (
        <div className="loaderContainer">
          <i className="fa fa-spinner fa-spin fa-2xl loader" />
        </div>
      ) : listState.error ? (
        <div className="loaderContainer error-style">
          <div className="error-icon">
            <i className="fa-solid fa-circle-exclamation"></i>
          </div>

          <span>{listState.error}</span>
        </div>
      ) : (
        <Container className="mt--6" fluid>
          {/* Profile Summary */}
          <Row className="justify-content-center">
            <Col md="6">
              <Card className="section-cards w-100">
                <CardBody className="text-center ">
                  {/* Profile Image */}
                  <Col xs="12" className="text-center ">
                    <FormGroup className="profile-photo-container text-center">
                      <div className="d-inline-block position-relative">
                        {formData.profilePhoto?.value ? (
                          <img
                            src={formData.profilePhoto.value.preview}
                            alt="profilePhoto"
                            className="profile-photo-preview"
                          />
                        ) : (
                          <Avatar name={formData.fullName?.value || ""} />
                        )}
                        <span
                          id="statusDot"
                          className={`status-dot ${
                            formData.accountStatus?.value === "ACTIVE"
                              ? "status-active"
                              : formData.accountStatus?.value === "INACTIVE"
                                ? "status-inactive"
                                : "status-default"
                          }`}
                        />

                        <Tooltip
                          placement="top"
                          isOpen={tooltipOpen}
                          target="statusDot"
                          toggle={toggle}
                        >
                          {formData.accountStatus?.value === "ACTIVE"
                            ? "Active"
                            : formData.accountStatus?.value === "INACTIVE"
                              ? "Inactive"
                              : "Unknown"}
                        </Tooltip>
                      </div>
                      {/* {profileState.isEditing && (
          <>
            <small className="text-muted d-block mt-2">
              Accepted formats: PNG, JPG. Maximum file size: 2 MB.
            </small>
            <span
              className="profile-img-edit cursor"
              onClick={() =>
                document.getElementById("profilePhotoInput").click()
              }
            >
              <i className="fa fa-camera" />
            </span>
            <Input
              type="file"
              id="profilePhotoInput"
              accept="image/png,image/jpeg"
              className="d-none"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file && file.size <= MAX_FILE_SIZE) {
                  handleInputChange("profilePhoto", file);
                }
              }}
            />
          </>
        )} */}
                    </FormGroup>
                  </Col>
                  {/* Name */}
                  <Col xs="12">
                    {profileState.isEditing ? (
                      <Row>
                        <Col md="6" className="mb-3">
                          <label className="small-label text-muted mb-1 d-block text-left">
                            First Name
                          </label>
                          <Input
                            type="text"
                            placeholder="First name"
                            value={formData.firstName?.value || ""}
                            onChange={(e) =>
                              handleInputChange("firstName", e.target.value)
                            }
                            onBlur={(e) =>
                              handleBlur("firstName", e.target.value)
                            }
                          />
                          {formData.firstName?.error && (
                            <small className="invalid-feedback d-block">
                              {formData.firstName.error}
                            </small>
                          )}
                        </Col>
                        <Col md="6">
                          <label className="small-label text-muted mb-1   d-block  text-left">
                            Last Name
                          </label>
                          <Input
                            type="text"
                            placeholder="Last name"
                            value={formData.lastName?.value || ""}
                            onChange={(e) =>
                              handleInputChange("lastName", e.target.value)
                            }
                            onBlur={(e) =>
                              handleBlur("lastName", e.target.value)
                            }
                          />
                          {formData.lastName?.error && (
                            <small className="invalid-feedback d-block">
                              {formData.lastName.error}
                            </small>
                          )}
                        </Col>
                      </Row>
                    ) : (
                      <h2 className="mb-0 text-default section-title">
                        {formData.firstName?.value || ""}{" "}
                        {formData.lastName?.value || ""}
                      </h2>
                    )}

                    <Label className="small-label text-muted mb-1">
                      {formData.role?.value || "Administrator"}
                    </Label>
                  </Col>
                  {/* Contact Chips */}
                  <div className="d-flex justify-content-center align-items-center flex-wrap mb-3">
                    <div className="mx-2 my-2">
                      <span className="td-meta-chip">
                        <i className="fas fa-envelope mr-2"></i>
                        {formData.email?.value || ""}
                      </span>
                    </div>

                    <div className="mx-2 my-2">
                      <span className="td-meta-chip">
                        <i className="fas fa-phone mr-2"></i>
                        +91 {formData.mobile?.value || ""}
                      </span>
                    </div>
                  </div>
                </CardBody>
                <CardFooter className="admin-profile-footer text-center">
                  {/* Created On */}
                  <Label className="small-label text-muted mb-1">
                    Account Created On
                  </Label>
                  <p className="small-text">
                    {formData.createdOn?.value || ""}
                  </p>
                  {/* Buttons */}

                  {!profileState.isEditing ? (
                    <Button
                      className="btn-deep-blue edit-reduced-height"
                      color="primary"
                      size="lg"
                      onClick={handleEdit}
                    >
                      <i className="fa-solid fa-pencil mr-2"></i>
                      Edit Profile
                    </Button>
                  ) : (
                    <>
                      <Button
                        color="secondary"
                        className="mr-2 btn-reduced-height"
                        size="lg"
                        onClick={handleOnCancel}
                      >
                        Cancel
                      </Button>

                      <Button
                        color="primary"
                        className="btn-deep-blue mr-2 btn-reduced-height"
                        size="lg"
                        onClick={handleSave}
                      >
                        Save
                      </Button>
                    </>
                  )}
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
}

export default AdminProfile;
